module.exports = __webpack_public_path__ + "static/media/presentation-board-graph.c6dcee11.svg";